import React from 'react';
import T from 'prop-types';
// icons
import { ReactComponent as DownloadIcon } from 'assets/svg/download-btn.svg';
// utils
import classnames from 'classnames/bind';
// styles
import styles from './ExportCSVButton.module.scss';

const cn = classnames.bind(styles);

const ExportCSVButton = ({ children, className, onClick }) => (
  <div className={cn('export-csv-btn', className)} onClick={onClick}>
    <DownloadIcon width={13} className="mh-5" />
    {children}
  </div>
);

ExportCSVButton.propTypes = {
  children: T.node.isRequired,
  className: T.string,
  onClick: T.func.isRequired,
};

ExportCSVButton.defaultProps = {
  className: '',
};

export default ExportCSVButton;
